import { render, staticRenderFns } from "./checkHistory.vue?vue&type=template&id=1271dc08&scoped=true&"
import script from "./checkHistory.vue?vue&type=script&lang=js&"
export * from "./checkHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1271dc08",
  null
  
)

export default component.exports